/*eslint-disable*/
import {
	Avatar,
	Button,
	Card,
	CardContent,
	Chip,
	CircularProgress,
	Divider,
	Icon,
	IconButton,
	InputAdornment,
	LinearProgress,
	List,
	ListItem,
	ListItemText,
	Paper,
	Popover,
	Snackbar,
	Table,
	TableBody,
	TableCell,
	TablePagination,
	TableRow,
	TextField,
	Typography
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { Search } from '@material-ui/icons';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import EnhancedTableHead from 'components/EnhancedTableHead/EnhancedTableHead.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import ManageClientsLegend from 'components/ManageClientsLegend/ManageClientsLegend.jsx';
import gql from 'graphql-tag';
import { DateTimeFormatter } from 'helpers/DateHelpers';
import { ParseGraphqlError } from 'helpers/ErrorHelper';
import { SearchDataSet } from 'helpers/Search';
import {
	GetUserId,
	GetUserKey,
	GetUserToken,
	Logout
} from 'helpers/UserHelper';
import { SendAppInvite } from 'queries/clients/mutations';
import { getClientsByBroker } from 'queries/clientsByBroker';
import { QuoteEligibility } from 'queries/QuoteEligibility';
import { newQuoteMutation } from 'queries/Submit';
import React from 'react';
import { compose, graphql, Mutation, Query } from 'react-apollo';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Redirect } from 'react-router';
import { showSnack, successWarning } from 'reducers/NotificationReducer';
import { openProgress } from 'reducers/TasksReducer';
import store from 'store';
import ClientImportModal from './ClientImportModal.jsx';
import SearchDialog from './advanced_search/SearchDialog.jsx';

const columnData = [
	{
		id: 'edit',
		numeric: false,
		disablePadding: true,
		label: '',
		noSort: true,
		width: '30px'
	},
	{
		id: 'clientType',
		numeric: false,
		disablePadding: true,
		label: '',
		noSort: true
	},
	{ id: 'scd_name', numeric: false, disablePadding: true, label: 'Name' },
	{ id: 'scd_email', numeric: false, disablePadding: true, label: 'Email' },
	{
		id: 'date_modified',
		numeric: false,
		disablePadding: true,
		label: 'Date Created / Modified'
	}
];

const isEmptyOrSpaces = str => {
	return str === undefined || str === null || str.match(/^ *$/) !== null;
};

export const ImportClients = gql`
	mutation importClients($input: ImportClientsInput!) {
		ImportClients(input: $input) {
			clientMutationId
		}
	}
`;

const exportClients = gql`
	mutation exportClients($input: ExportClientsInput!) {
		ExportClients(input: $input) {
			path
			clientMutationId
		}
	}
`;

const updateClientStatus = gql`
	mutation updateClientStatus($input: UpdateClientStatusInput!) {
		UpdateClientStatus(input: $input) {
			clientMutationId
		}
	}
`;

const deleteClient = gql`
	mutation deleteClient($input: DeleteClientInput!) {
		DeleteClient(input: $input) {
			clientMutationId
		}
	}
`;

class ManageClients extends React.Component {
	shouldComponentUpdate(nextProps, newState) {
		var comparedState = false;
		Object.keys(this.state).map(s => {
			if (this.state[s] !== newState[s]) {
				comparedState = true;
			}
			return s;
		});

		return comparedState;
	}

	state = {
		loading: true,
		page: 0,
		rowsPerPage: 5,
		order: 'desc',
		orderBy: 'date_modified',
		searchTerm: '',
		loadingSearch: false,
		searchData: [],
		openActions: false,
		statusEl: null,
		actionsEl: null,
		legendEl: null,
		handleStatusEl: null,
		openLoadingSnack: false,
		loadingSnackText: '',
		openMenus: [],
		anchorTop: 0,
		anchorLeft: 0,
		popoverOpen: false,
		clientStatus: 'own',
		data: [],
		openDialog: false,
		assistantActive: false,
		alert: false,
		eligibilityDialogOpen: false,
		invalidFields: [],
		selectedClient: {},
		openSearchDialog: false
	};

	exportPDF = () => {
		this.pdf.save();
	};

	handleSearch = event => {
		this.setState({ searchTerm: event.target.value });

		let values = event.target.value.split(' ');
		var brokers = this.state.data;
		var inc = ['scd_name', 'scd_surname', 'scd_email', 'date_created'];

		var filteredData = SearchDataSet(brokers, values, inc);
		this.setState({ searchData: filteredData });
	};

	handleChangePage = (event, page) => {
		this.setState({ page });
	};

	handleChangeRowsPerPage = event => {
		this.setState({ rowsPerPage: event.target.value });
	};

	handleRequestSort = (event, property) => {
		if (property === 'clientType') return;
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}

		this.setState({ order, orderBy });
	};

	getSorting(order, orderBy) {
		return order === 'desc'
			? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
			: (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
	}

	handleEdit(client, tab = null) {
		this.props.history.push({
			pathname: '/app/clientdetail',
			search: `clientId=${
				atob(client.id).split(':')[1]
			}&clientName=${(client.scd_name ? client.scd_name : '') +
				' ' +
				(client.scd_surname ? client.scd_surname : '')}${
				tab ? '&tab=' + tab : ''
			}`
		});
	}

	handleMedical(client, tab = null) {
		this.props.history.push({
			pathname: '/app/quotemedical',
			search: `clientId=${
				atob(client.id).split(':')[1]
			}`
		});
	}

	handlePopoverOpen = (event, name) => {
		this.setState({
			[name]: event.currentTarget
		});
	};

	handlePopoverClose = name => {
		this.setState({
			[name]: null
		});
	};

	loadingSnack = (open, text) => {
		this.setState({
			openLoadingSnack: open,
			loadingSnackText: text
		});
	};

	handleClick = (event, id) => {
		this.setState({ anchorTop: event.clientY, anchorLeft: event.clientX });

		var openMenus = this.state.openMenus.slice();
		openMenus.filter(x => x.id === id)[0].open = true;
		this.setState({ openMenus: openMenus, popoverOpen: true });
	};

	handleClose = id => {
		var openMenus = this.state.openMenus.slice();
		openMenus.filter(x => x.id === id)[0].open = false;
		this.setState({ openMenus: openMenus, popoverOpen: false });
	};

	handleImport = () => {
		this.setState({ openDialog: true });
	};

	handleCloseClientImport = () => {
		this.setState({ openDialog: false });
	};

	checkAssistantActive() {
		if (GetUserKey('userType') === '6') {
			if (!this.state.assistantActive) {
				this.setState({ assistantActive: true });
			}
			return true;
		}
		return false;
	}

	getBrokerId = () => {
		let brokerId = GetUserId();
		if (this.checkAssistantActive()) {
			brokerId = sessionStorage.getItem('ActiveBrokerId');
		}
		return brokerId;
	};

	getBrokerName = () => {
		return sessionStorage.getItem('ActiveBrokerName');
	};

	sortDateDesc = function(a, b) {
		return new Date(b.date_modified) - new Date(a.date_modified);
	};

	sortDateAsc = function(a, b) {
		return new Date(a.date_modified) - new Date(b.date_modified);
	};

	handleNewQuote = id => {
		this.props.history.push({
			pathname: '/app/quote',
			search: `clientId=${atob(id).split(':')[1]}`
		});
	};

	handleViewQuote = client => {
		const clientId = atob(client.id).split(':')[1];
		const clientFullName = client.scd_name + ' ' + client.scd_surname;

		this.props.history.push({
			pathname: `/app/history`,
			search: `clientId=${clientId}&clientName=${clientFullName}`
		});
	};

	handleSendMessage = id => {
		alert('Send a message to a client with id : ' + id);
		alert('THIS DOES NOTHING YET!');
	};

	handleSendAppInvite = (id, email, refetch) => {
		if (isEmptyOrSpaces(email)) {
			store.dispatch(
				showSnack({
					message: 'Client must have email address',
					color: 'danger'
				})
			);
			return;
		}
		const input = {
			clientId: atob(id).split(':')[1],
			clientEmail: email,
			brokerId: this.getBrokerId(),
			token: GetUserToken()
		};

		this.props
			.SendAppInvite({
				variables: {
					input
				}
			})
			.then(resp => {
				refetch();
				store.dispatch(
					showSnack({
						message: 'Invite Sent!',
						color: 'success'
					})
				);
			})
			.catch(error => {
				store.dispatch(
					showSnack({
						message: 'Error: ' + ParseGraphqlError(error),
						color: 'danger'
					})
				);
			});
	};

	handleRequestAstute = id => {
		const input = {
			token: GetUserToken(),
			userId: this.getBrokerId(),
			clientId: atob(id).split(':')[1],
			benefits: [3],
			assistantId: GetUserKey('userType') === '6' ? GetUserId() : null,
			targets: [7],
			data: {},
			requestAstute: true,
			astuteData: {}
		};

		this.props
			.newQuoteMutation({
				variables: {
					input
				}
			})
			.then(resp => {
				store.dispatch(
					successWarning({
						open: true,
						title: 'Astute Requested'
					})
				);
				store.dispatch(openProgress());
			})
			.catch(error => {
				store.dispatch(
					showSnack({
						message:
							'There was an error requesting Astute for this client: ' +
							ParseGraphqlError(error),
						color: 'danger'
					})
				);
			});
	};

	openSearchDialog = () => {
		this.setState({ openSearchDialog: true });
	};

	closeSearchDialog = () => {
		this.setState({ openSearchDialog: false });
	};

	render() {
		let brokerId = this.getBrokerId();

		return (
			<Query
				query={getClientsByBroker}
				variables={{
					brokerId: brokerId,
					token: GetUserKey('token'),
					status: this.state.clientStatus,
					userType: GetUserKey('userType')
				}}
				fetchPolicy="cache-and-network"
			>
				{({ loading, error, data, refetch }) => {
					if (loading) {
						return <LinearProgress />;
					} else {
						if (this.state.loading) this.setState({ loading: false });
					}

					if (
						error &&
						error.message &&
						error.message === 'GraphQL error: invalid token'
					) {
						Logout();
						return <Redirect to="/app/portal/login" />;
					}

					if (this.state.data.length !== data.getClientsByBroker.length) {
						this.setState({ data: data.getClientsByBroker });
					}

					let qData = [];
					if (
						this.state.searchData.length > 0 &&
						this.state.searchTerm !== ''
					) {
						qData = this.state.searchData.slice();
					} else {
						qData = data.getClientsByBroker.slice();
					}

					if (this.state.orderBy === 'date_modified') {
						qData.sort(
							this.state.order === 'desc' ? this.sortDateDesc : this.sortDateAsc
						);
					} else {
						qData.sort(this.getSorting(this.state.order, this.state.orderBy));
					}

					if (qData && this.state.openMenus.length !== qData.length) {
						let openMenus = [];

						qData.map(c => {
							openMenus.push({
								open: false,
								id: c.id
							});

							return cancelAnimationFrame;
						});

						this.setState({ openMenus: openMenus });
					}

					return (
						<React.Fragment>
							<Grid container>
								<GridItem xs={12} sm={12} md={10} style={{ margin: 'auto' }}>
									<Card>
										<CardContent>
											<div>
												{this.checkAssistantActive() ? (
													<Typography variant="headline" className="centerCell">
														{this.getBrokerName()}
														's Clients
													</Typography>
												) : (
													<Typography variant="headline" className="centerCell">
														Your Clients
													</Typography>
												)}

												<div
													style={{
														borderBottom: '1px solid #cccccc69',
														margin: '5px auto',
														width: '25%',
														marginBottom: '20px'
													}}
												/>
											</div>

											<Grid container style={{ marginBottom: '15px' }}>
												<Grid item xs={6} sm={6} md={6}>
													<Paper
														className="flabButton"
														onClick={e => this.handlePopoverOpen(e, 'statusEl')}
													>
														<div style={{ display: 'flex' }}>
															<Typography>Own / Unassigned</Typography>
															<Icon>arrow_drop_down</Icon>
														</div>
													</Paper>
													<Popover
														open={Boolean(this.state.statusEl)}
														anchorEl={this.state.statusEl}
														onClose={() => this.handlePopoverClose('statusEl')}
														anchorOrigin={{
															vertical: 'bottom',
															horizontal: 'center'
														}}
														transformOrigin={{
															vertical: 'top',
															horizontal: 'center'
														}}
													>
														<List component="nav">
															<ListItem
																button
																onClick={e => {
																	this.setState({ clientStatus: 'own' });
																	this.handlePopoverClose('statusEl');
																	refetch();
																}}
															>
																{this.state.clientStatus === 'own' ? (
																	<Icon>check</Icon>
																) : (
																	<div style={{ width: '24px' }} />
																)}

																<Typography
																	variant="subheading"
																	style={{
																		marginLeft: '10px',
																		marginRight: '10px'
																	}}
																>
																	Own
																</Typography>
															</ListItem>

															<Divider />
															<ListItem
																button
																onClick={e => {
																	this.setState({ clientStatus: 'shared' });
																	this.handlePopoverClose('statusEl');
																	refetch();
																}}
															>
																{this.state.clientStatus === 'shared' ? (
																	<Icon>check</Icon>
																) : (
																	<div style={{ width: '24px' }} />
																)}
																<Typography
																	variant="subheading"
																	style={{
																		marginLeft: '10px',
																		marginRight: '10px'
																	}}
																>
																	Unassigned
																</Typography>
															</ListItem>
															<Divider />
															<ListItem
																button
																onClick={e => {
																	this.setState({
																		clientStatus: 'deleted'
																	});
																	this.handlePopoverClose('statusEl');
																	refetch();
																}}
															>
																{this.state.clientStatus === 'deleted' ? (
																	<Icon>check</Icon>
																) : (
																	<div style={{ width: '24px' }} />
																)}
																<Typography
																	variant="subheading"
																	style={{
																		marginLeft: '10px',
																		marginRight: '10px'
																	}}
																>
																	Deleted
																</Typography>
															</ListItem>
														</List>
													</Popover>
												</Grid>
												<Grid item xs={6} sm={6} md={6}>
													<Paper
														className="flabButton"
														onClick={e => this.handlePopoverOpen(e, 'legendEl')}
													>
														<div style={{ display: 'flex' }}>
															<Typography>Legend</Typography>
															<Icon>arrow_drop_down</Icon>
														</div>
													</Paper>
													<Popover
														id="simple-popper"
														open={Boolean(this.state.legendEl)}
														anchorEl={this.state.legendEl}
														onClose={() => this.handlePopoverClose('legendEl')}
														anchorOrigin={{
															vertical: 'bottom',
															horizontal: 'center'
														}}
														transformOrigin={{
															vertical: 'top',
															horizontal: 'right'
														}}
													>
														<ManageClientsLegend />
													</Popover>
												</Grid>
											</Grid>

											<Paper style={{ overflowX: 'auto' }}>
												<Grid container>
													<Grid
														item
														xs={6}
														sm={4}
														md={3}
														style={{ margin: '25px auto 10px auto' }}
													>
														<Chip
															avatar={
																<Avatar
																	style={{
																		backgroundColor: '#6c5cab',
																		color: 'white'
																	}}
																>
																	<Icon>add</Icon>
																</Avatar>
															}
															className="customChip"
															variant="outlined"
															label={
																<Typography
																	style={{
																		color: 'white'
																	}}
																>
																	Add Client
																</Typography>
															}
															color="secondary"
															style={{
																backgroundColor: '#4239d659',
																color: 'white',
																width: '100%'
															}}
															onClick={() => {
																this.props.history.push({
																	pathname: '/app/CreateClient'
																});
															}}
														/>
													</Grid>

													<Grid
														item
														xs={6}
														sm={4}
														md={3}
														style={{
															margin: '25px auto 10px auto',
															textAlign: 'center'
														}}
													>
														<Button
															variant="outlined"
															style={{
																borderRadius: '20px',
																border: '1px solid #6c5cab',
																color: '#6c5cab'
															}}
															onClick={this.openSearchDialog}
														>
															Advanced search
														</Button>
													</Grid>

													<Grid
														item
														xs={12}
														sm={12}
														md={10}
														style={{ margin: '0 auto' }}
													>
														<TextField
															id="input-with-icon-textfield"
															fullWidth
															style={{ padding: '30px 0px 0px 0px' }}
															placeholder="Search Client by Name, Surname,Email or Date Created(YYYY/MM/DD)"
															onChange={this.handleSearch}
															InputProps={{
																startAdornment: (
																	<InputAdornment position="start">
																		<Search />
																	</InputAdornment>
																)
															}}
														/>
													</Grid>
												</Grid>

												<Table>
													<EnhancedTableHead
														order={this.state.order}
														orderBy={this.state.orderBy}
														onRequestSort={this.handleRequestSort}
														rowCount={
															this.state.searchData.length < 1 &&
															this.state.searchTerm !== ''
																? this.state.searchData.length
																: qData.length
														}
														columnData={columnData}
													/>
													<TableBody>
														{this.state.searchData.length < 1 &&
														this.state.searchTerm !== '' ? (
															<TableRow>
																<TableCell>
																	<h3>No results found</h3>
																</TableCell>
															</TableRow>
														) : (
															qData
																.slice(
																	this.state.page * this.state.rowsPerPage,
																	this.state.page * this.state.rowsPerPage +
																		this.state.rowsPerPage
																)
																.map(client => {
																	return (
																		//Hierso moet die mutation begin

																		<TableRow
																			key={client.id}
																			className="sqDataTable"
																			onClick={e =>
																				this.state.popoverOpen === false
																					? this.handleClick(e, client.id)
																					: null
																			}
																			style={
																				this.state.openMenus.length > 0 &&
																				this.state.openMenus.filter(
																					m => m.id === client.id
																				)[0] &&
																				this.state.openMenus.filter(
																					m => m.id === client.id
																				)[0].open
																					? { backgroundColor: '#dedede' }
																					: {}
																			}
																		>
																			<TableCell
																				style={{
																					padding: '0px',
																					borderRight: '1px solid #e0e0e0',
																					backgroundColor: 'white'
																				}}
																			>
																				<IconButton
																					onClick={e =>
																						this.state.popoverOpen === false
																							? this.handleClick(e, client.id)
																							: null
																					}
																				>
																					<Icon>more_vert</Icon>
																				</IconButton>
																			</TableCell>
																			<TableCell
																				style={{
																					borderTop:
																						'1px solid rgba(224, 224, 224, 1)',
																					width: '28px'
																				}}
																			>
																				<div style={{ display: 'flex' }}>
																					<Icon
																						style={
																							client.scd_clientType === 'active'
																								? { color: '#00ce00' }
																								: client.scd_clientType ===
																								  'prospect'
																								? { color: '#fbbb00' }
																								: { color: 'red' }
																						}
																					>
																						person_outline
																					</Icon>
																					<Icon
																						style={
																							client.app_info_complete === 1
																								? {
																										color: '#00ce00',
																										fontSize: '21px'
																								  }
																								: client.scd_registered === 1
																								? {
																										color: '#fbbb00',
																										fontSize: '21px'
																								  }
																								: client.invite_sent === 1
																								? {
																										color: 'red',
																										fontSize: '21px'
																								  }
																								: { display: 'none' }
																						}
																					>
																						smartphone
																					</Icon>
																					{!client.terrorCheck && (<Icon
																						style={
																							{
																								color: '#fbbb00',
																								fontSize: '21px'
																							}
																						}
																					>
																						warning
																					</Icon>)}
																					{client.terrorStatus && (<Icon
																						style={
																							{
																								color: 'red',
																								fontSize: '21px'
																							}
																						}
																					>
																						fingerprint
																					</Icon>)}
																				</div>
																			</TableCell>
																			<TableCell>
																				{client.scd_name} {client.scd_surname}
																			</TableCell>
																			<TableCell>{client.scd_email}</TableCell>
																			<TableCell>
																				{DateTimeFormatter(
																					client.date_modified
																				)}
																			</TableCell>
																			<Popover
																				open={
																					this.state.openMenus.length > 0 &&
																					this.state.openMenus.filter(
																						m => m.id === client.id
																					)[0]
																						? this.state.openMenus.filter(
																								m => m.id === client.id
																						  )[0].open
																						: false
																				}
																				anchorReference="anchorPosition"
																				anchorPosition={{
																					left: this.state.anchorLeft,
																					top: this.state.anchorTop
																				}}
																				onClose={() =>
																					this.handleClose(client.id)
																				}
																			>
																				<List component="nav">
																					{this.state.clientStatus === 'own' ? (
																						<div>
																							<ListItem
																								button
																								onClick={() =>
																									this.handleEdit(client)
																								}
																							>
																								<ListItemText primary="View/Edit Client" />
																							</ListItem>
																							<Divider />
																							<ListItem
																								button
																								onClick={() => {
																									this.handleSendAppInvite(
																										client.id,
																										client.scd_email,
																										refetch
																									);
																									this.handleClose(client.id);
																								}}
																							>
																								<ListItemText primary="Send App Invite" />
																							</ListItem>
																							<Divider />
																							<ListItem
																								button
																								onClick={() =>
																									this.handleEdit(
																										client,
																										'documents'
																									)
																								}
																							>
																								<ListItemText primary="View/Add Documents" />
																							</ListItem>
																							<Divider />
																							<Mutation
																								mutation={QuoteEligibility}
																								onCompleted={data => {
																									var quoteEligibility =
																										data.QuoteEligibility;
																									if (!quoteEligibility.valid) {
																										let invalidFields = quoteEligibility.invalidFields.split(
																											','
																										);
																										this.setState({
																											eligibilityDialogOpen: true,
																											invalidFields: invalidFields,
																											selectedClient: client
																										});
																									} else {
																										this.handleNewQuote(
																											client.id
																										);
																									}
																								}}
																								onError={error => {}}
																							>
																								{mutate => (
																									<ListItem
																										button
																										onClick={() =>
																											mutate({
																												variables: {
																													input: {
																														clientId: atob(
																															client.id
																														).split(':')[1]
																													}
																												}
																											})
																										}
																									>
																										<ListItemText primary="New Quote" />
																									</ListItem>
																								)}
																							</Mutation>
																							<Divider />
																							<ListItem
																								button
																								onClick={() =>
																									this.handleViewQuote(client)
																								}
																							>
																								<ListItemText primary="View Previous Quotes" />
																							</ListItem>
																							<Divider />
																							<ListItem
																								button
																								onClick={() =>
																									this.handleRequestAstute(
																										client.id
																									)
																								}
																							>
																								<ListItemText primary="Request Astute" />
																							</ListItem>
																							<Divider />

																							<ListItem
																								button
																								onClick={() =>
																									this.handleMedical(client)
																								}
																							>
																								<ListItemText primary="New Medical Aid Quote" />
																							</ListItem>
																							<Divider />



																							<Mutation
																								mutation={updateClientStatus}
																								onCompleted={data => {
																									store.dispatch(
																										successWarning({
																											open: true,
																											title: 'Client Deleted.'
																										})
																									),
																										refetch();
																								}}
																								onError={error => {
																									store.dispatch(
																										showSnack({
																											message:
																												'There was an error deleting the client.' +
																												error,
																											color: 'danger'
																										})
																									);
																								}}
																							>
																								{statusMutation => (
																									<ListItem
																										button
																										onClick={() => {
																											this.handleClose(
																												client.id
																											);
																											statusMutation({
																												variables: {
																													input: {
																														brokerId: GetUserId(),
																														token: GetUserToken(),
																														clientId: atob(
																															client.id
																														).split(':')[1],
																														status: 'deleted'
																													}
																												}
																											});
																										}}
																									>
																										<ListItemText primary="Delete Client" />
																									</ListItem>
																								)}
																							</Mutation>
																						</div>
																					) : this.state.clientStatus ===
																					  'shared' ? (
																						<Mutation
																							mutation={updateClientStatus}
																							onCompleted={data => {
																								store.dispatch(
																									successWarning({
																										open: true,
																										title: 'Client Claimed.'
																									})
																								),
																									refetch();
																							}}
																							onError={error => {
																								store.dispatch(
																									showSnack({
																										message:
																											'There was an error claiming this client.' +
																											error,
																										color: 'danger'
																									})
																								);
																							}}
																						>
																							{statusMutation => (
																								<ListItem
																									button
																									onClick={() => {
																										this.handleClose(client.id);
																										statusMutation({
																											variables: {
																												input: {
																													brokerId: GetUserId(),
																													token: GetUserToken(),
																													clientId: atob(
																														client.id
																													).split(':')[1],
																													status: 'own'
																												}
																											}
																										});
																									}}
																								>
																									<ListItemText primary="Claim Client" />
																								</ListItem>
																							)}
																						</Mutation>
																					) : (
																						<div>
																							<Mutation
																								mutation={updateClientStatus}
																								onCompleted={data => {
																									store.dispatch(
																										successWarning({
																											open: true,
																											title: 'Client Reclaimed.'
																										})
																									),
																										refetch();
																								}}
																								onError={error => {
																									store.dispatch(
																										showSnack({
																											message:
																												'There was an error reclaiming this client.' +
																												error,
																											color: 'danger'
																										})
																									);
																								}}
																							>
																								{statusMutation => (
																									<ListItem
																										button
																										onClick={() => {
																											this.handleClose(
																												client.id
																											);
																											statusMutation({
																												variables: {
																													input: {
																														brokerId: GetUserId(),
																														token: GetUserToken(),
																														clientId: atob(
																															client.id
																														).split(':')[1],
																														status: 'own'
																													}
																												}
																											});
																										}}
																									>
																										<ListItemText primary="Reclaim Client" />
																									</ListItem>
																								)}
																							</Mutation>
																							<Divider />
																							<Mutation
																								mutation={deleteClient}
																								onCompleted={data => {
																									store.dispatch(
																										successWarning({
																											open: true,
																											title:
																												'Client Permanently Deleted.'
																										})
																									),
																										refetch();
																								}}
																								onError={error => {
																									store.dispatch(
																										showSnack({
																											message:
																												'There was an error permanently deleting this client.' +
																												error,
																											color: 'danger'
																										})
																									);
																								}}
																							>
																								{deleteClientMutation => (
																									<ListItem
																										button
																										onClick={() => {
																											this.handleClose(
																												client.id
																											);
																											deleteClientMutation({
																												variables: {
																													input: {
																														token: GetUserToken(),
																														clientId: atob(
																															client.id
																														).split(':')[1]
																													}
																												}
																											});
																										}}
																									>
																										<ListItemText primary="Permanently Delete Client" />
																									</ListItem>
																								)}
																							</Mutation>
																						</div>
																					)}
																				</List>
																			</Popover>
																		</TableRow>
																	);
																})
														)}
														<TableRow>
															<TablePagination
																count={
																	this.state.searchData.length < 1 &&
																	this.state.searchTerm !== ''
																		? this.state.searchData.length
																		: qData.length
																}
																rowsPerPage={this.state.rowsPerPage}
																page={this.state.page}
																backIconButtonProps={{
																	'aria-label': 'Previous Page'
																}}
																nextIconButtonProps={{
																	'aria-label': 'Next Page'
																}}
																onChangePage={this.handleChangePage}
																onChangeRowsPerPage={
																	this.handleChangeRowsPerPage
																}
															/>
														</TableRow>
													</TableBody>
												</Table>
											</Paper>
										</CardContent>
									</Card>
								</GridItem>
							</Grid>

							<Snackbar
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right'
								}}
								open={this.state.openLoadingSnack}
								ContentProps={{
									'aria-describedby': 'message-id'
								}}
								message={
									<span>
										<CircularProgress
											color="secondary"
											size={20}
											style={{
												marginRight: '15px',
												position: 'relative',
												top: '5px'
											}}
										/>
										{this.state.loadingSnackText}
									</span>
								}
							/>
							<ClientImportModal
								open={this.state.openDialog}
								closeDialog={this.handleCloseClientImport}
								userType={GetUserKey('userType')}
								loadingSnack={this.loadingSnack}
								doneImporting={() =>
									store.dispatch(
										successWarning({
											open: true,
											title: 'Clients Imported!',
											onConfirm: () =>
												this.props.history.push({
													pathname: '/app/ManageClients'
												})
										})
									)
								}
							/>
							{this.state.eligibilityDialogOpen ? (
								<SweetAlert
									warning
									style={{ wordWrap: 'break-word', top: '40%' }}
									title={'Ineligible'}
									confirmBtnCssClass={
										this.props.classes.button + ' ' + this.props.classes.success
									}
									cancelBtnCssClass={
										this.props.classes.button + ' ' + this.props.classes.danger
									}
									confirmBtnText="Edit Client"
									cancelBtnText="Close"
									onConfirm={() => {
										this.handleEdit(this.state.selectedClient);
									}}
									onCancel={() => {
										this.setState({
											eligibilityDialogOpen: false
										});
									}}
									showCancel={!this.state.loadingDelete}
									showConfirm={!this.state.loadingDelete}
								>
									<Typography>
										{this.state.selectedClient.scd_name +
											' ' +
											this.state.selectedClient.scd_surname +
											' '}
										is ineligible for a quote.
									</Typography>
									<br />
									<Typography>Please update the following fields: </Typography>
									<Grid container className="invalidListBlock">
										{this.state.invalidFields.map(i => {
											return (
												<Grid item xs={12} sm={6} md={6}>
													<Typography>{i}</Typography>
												</Grid>
											);
										})}
									</Grid>
								</SweetAlert>
							) : null}

							{this.state.openSearchDialog ? (
								<SearchDialog
									history={this.props.history}
									open={true}
									closeDialog={this.closeSearchDialog}
								/>
							) : null}
						</React.Fragment>
					);
				}}
			</Query>
		);
	}
}

ManageClients = compose(
	graphql(SendAppInvite, { name: 'SendAppInvite' }),
	graphql(newQuoteMutation, { name: 'newQuoteMutation' })
)(ManageClients);

export default withStyles(sweetAlertStyle)(ManageClients);



// WEBPACK FOOTER //
// ./src/views/Clients/components/ManageClients.jsx